import React from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../../core/utils/alert";
import { useCourseFeeShare } from "./hooks/useCourseFeeShare";

interface CourseFeeShareModalsProps {
  feeShareId?: string;
  onSuccess?: () => void;
}

const CourseFeeShareModals: React.FC<CourseFeeShareModalsProps> = ({
  feeShareId,
  onSuccess,
}) => {
  const { deleteFeeShare, isDeleting } = useCourseFeeShare();

  // Handle delete function
  const handleDelete = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!feeShareId) return;

    try {
      const result = await deleteFeeShare(feeShareId);

      if (result.success) {
        showToast({
          title: "Success",
          text: "Fee share deleted successfully",
          icon: "success",
        });

        // Call the success callback if provided
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      // Error is already handled in the hook
      console.error("Error in delete fee share:", error);
    }
  };

  return (
    <>
      {/* Delete Modal */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleDelete}>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-trash fs-24" />
                </span>
                <h4>Delete Fee Share</h4>
                <p className="mb-4">
                  Are you sure you want to delete this fee share?
                  <br />
                  <small className="text-danger">
                    This action cannot be undone.
                  </small>
                </p>
                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-light me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                        ></span>
                        Deleting...
                      </>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseFeeShareModals;
